import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Product } from '../../types/product';
import Button from './Button';
import ProfitCalculator from './ProfitCalculator';
import {useTranslation} from "react-i18next";

interface ProductCardProps {
  product: Product;
}

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Проверяем наличие хеша в URL
    if (location.hash) {
      // Получаем ID элемента из хеша
      const id = location.hash.substring(1); // удаляем символ #
      
      // Находим элемент
      const element = document.getElementById(id);
      
      // Прокручиваем до элемента, если он найден
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  // Обработчик для кнопки "Подробнее"
  const handleDetailsClick = () => {
    navigate(`/products/${product.id}`);
  };
  

  const registerToMiniapp = () => {
    window.location.href = "https://account.kirenagainvest.com/registration"
    };
    const { t } = useTranslation() as {
        t: (key: string, options?: any) => string;
    };
  return (
    <div id={product.id} className={`py-12 ${product.title.toLowerCase() == 'casino' ? '':'border-b'} border-gray-950 `}>
        <div className="flex flex-col gap-6 justify-between items-left md:items-center mb-16 md:flex-row md:gap-0">
        <h2 className="text-4xl text-left font-bold
        md:text-7xl
        lg:text-8xl
        xl:text-9xl

        tracking-[-2px]
        ">{product.title}</h2>
        {(product.pdfUrl && !['cannabis', 'casino'].includes(product.title.toLowerCase())) && (
            <>
            <a 
                href={process.env.PUBLIC_URL + '/assets/pdf/'+ t(product.pdfUrl)}
                target="_blank"
                rel="noopener noreferrer"
                className="hidden md:block bg-brand-gray font-druk text-[#D4FB00] px-4 py-2 rounded-lg hover:bg-opacity-90"
                >
            PDF
            </a>
            <a 
                href={'/assets/pdf/'+ t(product.pdfUrl)}
                target="_blank"
                rel="noopener noreferrer"
                className="block md:hidden text-2xl bg-brand-gray text-[#D4FB00] px-6 py-2 rounded-lg hover:bg-opacity-90 font-medium w-fit"
                >
                {t('Download PDF')}
            </a>
            </>
        )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="flex flex-col justify-around">
                <p className="mb-12 text-2xl md:text-xl xl:text-2xl font-medium uppercase"  dangerouslySetInnerHTML={{ __html: product.description }}></p>
                {
                product.title.toLowerCase() === 'cannabis' || product.title.toLowerCase() === 'casino' ?
                    <button disabled={true} className="bg-gray-700 text-white px-10 py-3 rounded-xl hover:bg-opacity-90 flex max-w-fit">
                        {t('Waiting')}
                    </button>
                :
                    <div className="flex flex-wrap gap-4 text-xl font-medium">
                        <button 
                        className="bg-[#000000] bg-opacity-80 text-[#D4FB00] md:text-xl md:font-druk px-6 md:px-10 py-3 rounded-xl hover:bg-opacity-90"
                        onClick={() => registerToMiniapp()}
                        >
                        {t('start')}
                        </button>
                        <button
                        className="bg-[#000000] bg-opacity-80 text-[#D4FB00] md:text-xl md:font-druk px-6 md:px-10 py-3 rounded-xl hover:bg-opacity-90"
                        onClick={handleDetailsClick}
                        >
                            {t('Details')}
                        </button>
                    </div>
                }
            </div>

            <div>
                <ProfitCalculator 
                productId={product.id}
                initialAmount={product.calculatorDefaults.initialInvestment}
                />
            </div>
        </div>
    </div>
  );
};

export default ProductCard;